












































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import dayjs from 'dayjs';
import DoughnutChart from '@/components/recruitment/dashboard/DoughnutChart.vue';
import LineChart from '@/components/recruitment/dashboard/LineChart.vue';
import { Job } from '@/components/recruitment/dashboard/data/jobs';

@Component({
  components: {
    DoughnutChart,
    LineChart,
  },
})

export default class AnalyticsData extends Vue {
  @Prop(String)
  private type!: string;
  @Prop(Array)
  private jobs!: Array<Job>;
  @Prop(String)
  private periodFromDefault!: string;
  @Prop(String)
  private periodToDefault!: string;
  @Prop(Number)
  private total!: number;
  @Prop(Object)
  private compared!: {
    periodFrom: string;
    periodTo: string;
    total: number;
  };
  @Prop(Array)
  private lineChartData!: Array<{
    label: string;
    value: number;
  }>;
  @Prop(Object)
  private lineChartOption!: {
    yAxesTicksMin: number;
    yAxesTicksMax: number;
    yAxesTicksStepSize: number;
  };
  @Prop(Array)
  private doughnutChartData!: Array<{
    label: string;
    value: number;
    color: string;
  }>;

  private jobId: string = '99';
  private searchJobWord: string = '';
  private periodDatePicker: boolean = false;
  private period: Array<string> = [this.periodFromDefault, this.periodToDefault];

  private get selectedJobName() {
    if (this.jobId === '99') {
      return 'すべての求人案件 ▼';
    }
    const selectedJob = this.jobs.find(({ id }: { id: string; }) => id === this.jobId);
    return selectedJob ? `${selectedJob.name} ▼` : '';
  };
  private get filteredJobs() {
    return this.jobs.filter(({ name }: { name: string }) => name.indexOf(this.searchJobWord) !== -1);
  };
  private get rate() {
    if (this.total === 0) {
      return null;
    }
    if (this.total >= this.compared.total) {
      return Math.round((this.total - this.compared.total) / this.total * 100);
    }
    return Math.round((this.compared.total - this.total) / this.total * 100);
  };

  private selectJob(jobId: string) {
    this.jobId = jobId;
    this.displayAnalyticsData();
  };
  private displayAnalyticsData() {
    if (dayjs(this.period[0]).isAfter(this.period[1])) {
      const periodFrom = this.period[1];
      const periodTo = this.period[0];
      this.period[0] = periodFrom;
      this.period[1] = periodTo;
    }

    return this.$emit('displayAnalyticsData', {
      jobId: this.jobId,
      periodFrom: this.period[0],
      periodTo: this.period[1],
    });
  };
}
